var _g, _path, _path2, _path3, _path4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBronze(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_101_364)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_101_364",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.75 4.4C3.75 3.35066 4.60066 2.5 5.65 2.5L44.35 2.5C45.3993 2.5 46.25 3.35066 46.25 4.4V27.25C46.25 38.4338 36.3333 47.5 25 47.5C13.6667 47.5 3.75 38.4338 3.75 27.25V4.4Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M3.75 4.4C3.75 3.35066 4.60066 2.5 5.65 2.5L44.35 2.5C45.3993 2.5 46.25 3.35066 46.25 4.4V27.25C46.25 38.4338 36.3333 47.5 25 47.5C13.6667 47.5 3.75 38.4338 3.75 27.25V4.4Z",
    fill: "url(#paint0_linear_101_364)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.65 2.5L5.65 4.5L5.65 2.5ZM44.35 2.5L44.35 0.500001L44.35 2.5ZM44.25 4.4V27.25H48.25V4.4H44.25ZM5.75 27.25V4.4H1.75V27.25H5.75ZM25 45.5C14.6541 45.5 5.75 37.2156 5.75 27.25H1.75C1.75 39.6519 12.6792 49.5 25 49.5V45.5ZM44.25 27.25C44.25 37.2156 35.3459 45.5 25 45.5V49.5C37.3208 49.5 48.25 39.6519 48.25 27.25H44.25ZM5.65 4.5L44.35 4.5L44.35 0.500001L5.65 0.5L5.65 4.5ZM5.75 4.4C5.75 4.45523 5.70523 4.5 5.65 4.5L5.65 0.5C3.49609 0.5 1.75 2.24609 1.75 4.4H5.75ZM48.25 4.4C48.25 2.24609 46.5039 0.500001 44.35 0.500001L44.35 4.5C44.2948 4.5 44.25 4.45523 44.25 4.4H48.25Z",
    fill: "white",
    fillOpacity: 0.4,
    mask: "url(#path-1-inside-1_101_364)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.6976 21.6844C24.8243 21.4385 25.1757 21.4385 25.3024 21.6844L26.1074 23.2461C26.1398 23.309 26.191 23.3602 26.2539 23.3926L27.8156 24.1976C28.0615 24.3243 28.0615 24.6757 27.8156 24.8024L26.2539 25.6074C26.191 25.6398 26.1398 25.691 26.1074 25.7539L25.3024 27.3156C25.1757 27.5615 24.8243 27.5615 24.6976 27.3156L23.8926 25.7539C23.8602 25.691 23.809 25.6398 23.7461 25.6074L22.1844 24.8024C21.9385 24.6757 21.9385 24.3243 22.1844 24.1976L23.7461 23.3926C23.809 23.3602 23.8602 23.309 23.8926 23.2461L24.6976 21.6844Z",
    fill: "url(#paint1_angular_101_364)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6976 21.6844C24.8243 21.4385 25.1757 21.4385 25.3024 21.6844L26.1074 23.2461C26.1398 23.309 26.191 23.3602 26.2539 23.3926L27.8156 24.1976C28.0615 24.3243 28.0615 24.6757 27.8156 24.8024L26.2539 25.6074C26.191 25.6398 26.1398 25.691 26.1074 25.7539L25.3024 27.3156C25.1757 27.5615 24.8243 27.5615 24.6976 27.3156L23.8926 25.7539C23.8602 25.691 23.809 25.6398 23.7461 25.6074L22.1844 24.8024C21.9385 24.6757 21.9385 24.3243 22.1844 24.1976L23.7461 23.3926C23.809 23.3602 23.8602 23.309 23.8926 23.2461L24.6976 21.6844Z",
    fill: "url(#paint2_angular_101_364)",
    fillOpacity: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7469 21.4553C25.434 20.8482 24.566 20.8482 24.2531 21.4553L23.4716 22.9716L21.9553 23.7531C21.3482 24.066 21.3482 24.934 21.9553 25.2469L23.4716 26.0284L24.2531 27.5447C24.566 28.1518 25.434 28.1518 25.7469 27.5447L26.5284 26.0284L28.0447 25.2469C28.6518 24.934 28.6518 24.066 28.0447 23.7531L26.5284 22.9716L25.7469 21.4553Z",
    stroke: "black",
    strokeOpacity: 0.16
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.1123 34.2812L36.8935 2.5L44.3504 2.5C45.3997 2.5 46.2504 3.35066 46.2504 4.4V14.3563L15.382 45.2247C10.7415 42.9169 7.00905 39.0163 5.1123 34.2812Z",
    fill: "white",
    fillOpacity: 0.32
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_101_364",
    x: 3.75,
    y: 2.5,
    width: 42.5,
    height: 45.95,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.95
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.24 0 0 0 0 0.118652 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_101_364"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_101_364",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_101_364",
    x1: 24.9998,
    y1: 56.5764,
    x2: 24.9997,
    y2: 3.06253,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8C4500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1A66E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_angular_101_364",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(25 24.5) rotate(90) scale(3)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E0E0E0"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_angular_101_364",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(25 24.5) rotate(-180) scale(3)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E0E0E0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBronze);
export default __webpack_public_path__ + "static/media/bronze.e9246ab3f9054d5f96d0a389e6362475.svg";
export { ForwardRef as ReactComponent };